import { render, staticRenderFns } from "./BoundarySelector.vue?vue&type=template&id=5bce876d&scoped=true&lang=pug&"
import script from "./BoundarySelector.vue?vue&type=script&lang=js&"
export * from "./BoundarySelector.vue?vue&type=script&lang=js&"
import style0 from "./BoundarySelector.vue?vue&type=style&index=0&id=5bce876d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce876d",
  null
  
)

export default component.exports